<template>
  <div class="thumb-admin">
    <h3>{{ $tt("缩略图补全任务") }}</h3>
    <el-card shadow="never" class="mb">
      <el-switch v-model="jobEnabled" :active-text="$tt('定时任务开启')" @change="onToggle" />
      <el-button type="primary" size="small" style="margin-left: 16px" :loading="running" @click="runNow">
        {{ $tt("立即执行") }}
      </el-button>
      <el-button size="small" @click="retryFailures">{{ $tt("重试失败项") }}</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="refresh">{{ $tt("刷新") }}</el-button>
      <div class="stats" v-if="snapshot">
        <span>{{ $tt("待处理(私有)") }}: {{ snapshot.pendingPrivate }}</span>
        <span>{{ $tt("待处理(公共)") }}: {{ snapshot.pendingPublic }}</span>
        <span>{{ $tt("失败") }}: {{ snapshot.failureCount }}</span>
        <span v-if="snapshot.running">{{ $tt("运行中…") }}</span>
      </div>
    </el-card>

    <el-card shadow="never" class="mb">
      <div slot="header">{{ $tt("最近 3 次周期") }}</div>
      <el-table :data="runs" size="small" @row-click="loadItems">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="triggerType" :label="$tt('触发')" width="90" />
        <el-table-column prop="status" :label="$tt('状态')" width="90" />
        <el-table-column prop="processed" :label="$tt('处理')" width="70" />
        <el-table-column prop="successCount" :label="$tt('成功')" width="70" />
        <el-table-column prop="failCount" :label="$tt('失败')" width="70" />
        <el-table-column prop="startedAt" :label="$tt('开始')" min-width="140" />
        <el-table-column prop="finishedAt" :label="$tt('结束')" min-width="140" />
      </el-table>
    </el-card>

    <el-card shadow="never" class="mb" v-if="selectedRunId">
      <div slot="header">{{ $tt("周期明细") }} #{{ selectedRunId }}</div>
      <el-table :data="runItems" size="small" max-height="360">
        <el-table-column prop="fileRealName" :label="$tt('名称')" min-width="120" show-overflow-tooltip />
        <el-table-column prop="status" :label="$tt('结果')" width="70" />
        <el-table-column :label="$tt('缩略图')" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.fileThumbPath"
              :src="scope.row.fileThumbPath"
              fit="contain"
              style="width: 64px; height: 48px"
              :preview-src-list="[scope.row.fileThumbPath]"
            />
          </template>
        </el-table-column>
        <el-table-column prop="errorMessage" :label="$tt('错误')" min-width="160" show-overflow-tooltip />
        <el-table-column prop="durationMs" :label="$tt('耗时ms')" width="80" />
      </el-table>
    </el-card>

    <el-card shadow="never">
      <div slot="header">{{ $tt("失败列表") }}</div>
      <el-table :data="failures" size="small" max-height="280">
        <el-table-column prop="sourceTable" :label="$tt('表')" width="140" />
        <el-table-column prop="fileId" :label="$tt('素材ID')" min-width="120" show-overflow-tooltip />
        <el-table-column prop="lastError" :label="$tt('错误')" min-width="200" show-overflow-tooltip />
        <el-table-column prop="retryCount" :label="$tt('重试次数')" width="90" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jobEnabled: true,
      running: false,
      snapshot: null,
      runs: [],
      runItems: [],
      selectedRunId: null,
      failures: [],
      pollTimer: null,
    };
  },
  mounted() {
    this.refresh();
  },
  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  },
  methods: {
    async refresh() {
      try {
        const st = await this.$request.status();
        if (st.status === "success") {
          this.snapshot = st.data || {};
          this.jobEnabled = !!this.snapshot.jobEnabled;
          this.running = !!this.snapshot.running;
        }
        const rr = await this.$request.runs(3);
        if (rr.status === "success") this.runs = rr.data || [];
        const ff = await this.$request.failures();
        if (ff.status === "success") this.failures = ff.data || [];
      } catch (e) {
        console.error(e);
      }
    },
    async onToggle(val) {
      const res = await this.$request.setEnabled(val);
      if (res.status !== "success") this.$message.error(res.msg);
      else this.refresh();
    },
    async runNow() {
      this.running = true;
      const res = await this.$request.runNow();
      if (res.status !== "success") {
        this.$message.error(res.msg);
        this.running = false;
        return;
      }
      this.$message.success(this.$tt("任务已启动"));
      this.pollTimer = setInterval(() => this.refresh(), 2000);
      setTimeout(() => {
        if (this.pollTimer) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
        }
        this.refresh();
      }, 60000);
    },
    async retryFailures() {
      const res = await this.$request.retryFailures();
      if (res.status !== "success") this.$message.error(res.msg);
      else {
        this.$message.success(this.$tt("已触发"));
        this.refresh();
      }
    },
    async loadItems(row) {
      this.selectedRunId = row.id;
      const res = await this.$request.runItems(row.id);
      if (res.status === "success") this.runItems = res.data || [];
    },
  },
};
</script>

<style scoped>
.thumb-admin {
  padding: 20px;
  background: #fff;
}
.mb {
  margin-bottom: 16px;
}
.stats span {
  margin-right: 16px;
  font-size: 13px;
  color: #606266;
}
</style>
